import { createContext, useContext } from 'react'
import { Node } from 'prosemirror-model'
import { EditorView, Decoration, NodeView } from 'prosemirror-view'
import { type ReactNodeView } from './ReactNodeView'

export type ViewGetPosition = () => number

export interface IReactNodeViewContext {
  node: Node
  view: EditorView
  getPos: ViewGetPosition
  decorations: Decoration[]
  nodeView: ReactNodeView & NodeView
  inCommentMode: boolean
  isSelected: boolean
}

export const ReactNodeViewContext = createContext<Partial<IReactNodeViewContext>>({
  node: undefined,
  view: undefined,
  getPos: undefined,
  decorations: undefined,
  nodeView: undefined,
  inCommentMode: false,
  isSelected: false,
})

export const useReactNodeView = () => useContext(ReactNodeViewContext) as IReactNodeViewContext
